import {useTranslation} from 'react-i18next';

import {CodeEditor, CopyText, Icon, Tooltip} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.CONTENT.CLIENT_SESSION.WHITE_LABEL;

type Props = {
    language: 'html' | 'css';
    placeholder: string;
    value: string;
    onUpdate: (value: string) => void;
    onReset: () => void;
    onPreview?: () => void;
}

export const WhiteLabelEditor = ({placeholder, value, onUpdate, onReset, onPreview}: Props) => {
    const {t} = useTranslation();

    return (
        <div className='tw-flex tw-flex-col -md:tw-mb-8'>
            <div className='tw-flex tw-justify-between tw-mb-1'>
                <div>{placeholder}</div>
                <div className='tw-flex tw-gap-2'>
                    <CopyText
                        text={value}
                        textInTooltip={false}
                        iconOnly
                        iconColor='default'
                        copiedLabelOnly
                    />
                    <Tooltip header={t(T_KEYS.RESET_TO_DEFAULT)}>
                        <Icon
                            name='corner-up-left'
                            button
                            color='default'
                            onClick={onReset}
                        />
                    </Tooltip>
                    {onPreview &&
                        <Tooltip header={t(T_KEYS.PREVIEW)}>
                            <Icon
                                name='eye'
                                button
                                color='default'
                                onClick={onPreview}
                            />
                        </Tooltip>}
                </div>
            </div>
            <CodeEditor
                className='tw-flex-1'
                language='html'
                value={value}
                onChange={onUpdate}
            />
        </div>
    );
};